import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    class: "flex-grow-1 bg-transparent",
    style: { "flex": "1 1 auto", "overflow-y": "auto" }
};
const _hoisted_2 = {
    key: 0,
    style: { "height": "60px", "position": "relative" }
};
const _hoisted_3 = {
    key: 1,
    class: "list-unstyled"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    style: { "display": "flex", "flex-direction": "row", "padding": "10px" },
    class: "small"
};
const _hoisted_6 = {
    style: { "flex": "0 0 30px", "display": "flex", "align-items": "center", "justify-content": "center", "height": "100%" },
    class: "color__text-primary text-center"
};
const _hoisted_7 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-square",
    viewBox: "0 0 16 16"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("path", { d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-check-square-fill",
    viewBox: "0 0 16 16"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("path", { d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" }, null, -1);
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = { style: { "flex": "1 1 auto", "padding-left": "10px" } };
const _hoisted_14 = { style: { "display": "flex", "flex-direction": "column" } };
const _hoisted_15 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_16 = { style: { "flex": "1 1 auto", "font-weight": "600" } };
const _hoisted_17 = {
    class: "p-2 bg-light container-fluid",
    style: { "flex": "0 0 40px" }
};
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-12" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("small", null, "Anzeigen", -1);
const _hoisted_21 = [
    _hoisted_20
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", {
        onOnshow: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.onShow && _ctx.onShow(...args))),
        style: { "position": "relative", "display": "flex", "flex-direction": "column", "width": "100%", "height": "100%" },
        class: "mini-cart"
    }, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_g_loader, { size: "30px" })
                ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: "border-bottom",
                            onClick: _withModifiers(($event) => (_ctx.onSelect(account)), ["stop", "prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (_ctx.accountID === account.accountID)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, _toDisplayString(account.displayName), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ], 8, _hoisted_4));
                    }), 256))
                ]))
        ]),
        _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                        onClick: _ctx.onclose,
                        to: "/service/accounts"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("button", {
                                class: "btn btn-outline-primary w-100 btn-sm",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                            }, _hoisted_21)
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ])
            ])
        ])
    ], 32));
}
